export function dateFormat(timestamp: number, locale: string) {
  return new Date(timestamp * 1000).toLocaleDateString(locale)
}

const KEY = 'messages'

export function clearMessages() {
  return localStorage.removeItem(KEY)
}

export async function clearCacheStorage() {
  if (window.caches) {
    const cacheKeys = await window.caches.keys()
    await Promise.all(cacheKeys.map(key => window.caches.delete(key)))
  }
}

export function forceHomeReload() {
  const {
    protocol,
    hostname,
    port,
  } = window.location
  const url = [protocol, '//', hostname]
  if (port)
    url.push(...[':', port])

  const ts = new Date().getTime()

  const newUrl = `${url.join('')}?ts=${ts}`
  fetch(url.join(''), { cache: 'reload', headers: { 'Clear-Site-Data': 'storage' } }).finally(() => {
    window.location.href = newUrl
  })
}

export async function hotReload() {
  await clearCacheStorage()
  clearMessages()
  forceHomeReload()
}

export function versionToNumber(version?: string): number {
  if (!version)
    return 0
  return Number(version.replace(/\./g, ''))
}
